import type { LauncherPosition } from "../../core/config/public-config.types.ts";

const fallbackLauncherPosition: LauncherPosition = "bottom-right";

const launcherPositions = new Set<LauncherPosition>([
  "bottom-left",
  "bottom-right",
  "top-left",
  "top-right",
]);

const accessibilityIconSvg = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
  <path d="M24.75 15C24.75 12.4141 23.7228 9.93419 21.8943 8.10571C20.0658 6.27723 17.5859 5.25 15 5.25C12.4141 5.25 9.93419 6.27723 8.10571 8.10571C6.27723 9.93419 5.25 12.4141 5.25 15C5.25 17.5859 6.27723 20.0658 8.10571 21.8943C9.93419 23.7228 12.4141 24.75 15 24.75C17.5859 24.75 20.0658 23.7228 21.8943 21.8943C23.7228 20.0658 24.75 17.5859 24.75 15ZM3 15C3 11.8174 4.26428 8.76516 6.51472 6.51472C8.76516 4.26428 11.8174 3 15 3C18.1826 3 21.2348 4.26428 23.4853 6.51472C25.7357 8.76516 27 11.8174 27 15C27 18.1826 25.7357 21.2348 23.4853 23.4853C21.2348 25.7357 18.1826 27 15 27C11.8174 27 8.76516 25.7357 6.51472 23.4853C4.26428 21.2348 3 18.1826 3 15ZM10.5703 10.9641L11.1281 11.2031C12.3516 11.7281 13.6688 12 15.0047 12C16.3406 12 17.6531 11.7281 18.8812 11.2031L19.4391 10.9641C20.0109 10.7203 20.6719 10.9828 20.9156 11.5547C21.1594 12.1266 20.8969 12.7875 20.325 13.0312L19.7672 13.2703C18.9563 13.6172 18.1172 13.875 17.2547 14.0344V16.3828C17.2547 16.5844 17.2875 16.7859 17.3531 16.9734L18.6984 21.0094C18.8953 21.6 18.5766 22.2375 17.9859 22.4344C17.3953 22.6313 16.7578 22.3125 16.5609 21.7219L15.4172 18.2906C15.3562 18.1125 15.1922 17.9906 15.0047 17.9906C14.8172 17.9906 14.6484 18.1125 14.5922 18.2906L13.4484 21.7219C13.2516 22.3125 12.6141 22.6313 12.0234 22.4344C11.4328 22.2375 11.1094 21.6094 11.3062 21.0187L12.6516 16.9828C12.7172 16.7906 12.75 16.5938 12.75 16.3922V14.0438C11.8875 13.8797 11.0484 13.6266 10.2375 13.2797L9.67969 13.0406C9.10781 12.7969 8.84531 12.1359 9.08906 11.5641C9.33281 10.9922 9.99375 10.7297 10.5656 10.9734L10.5703 10.9641ZM15 6.75C15.4973 6.75 15.9742 6.94754 16.3258 7.29917C16.6775 7.65081 16.875 8.12772 16.875 8.625C16.875 9.12228 16.6775 9.59919 16.3258 9.95083C15.9742 10.3025 15.4973 10.5 15 10.5C14.5027 10.5 14.0258 10.3025 13.6742 9.95083C13.3225 9.59919 13.125 9.12228 13.125 8.625C13.125 8.12772 13.3225 7.65081 13.6742 7.29917C14.0258 6.94754 14.5027 6.75 15 6.75Z" fill="currentColor"/>
</svg>
`;

export type CreateLauncherButtonInput = {
  document?: Document;
  onToggle: () => void;
  position: unknown;
};

export function normalizeLauncherPosition(value: unknown): LauncherPosition {
  return launcherPositions.has(value as LauncherPosition)
    ? (value as LauncherPosition)
    : fallbackLauncherPosition;
}

export function createLauncherButton({
  document = globalThis.document,
  onToggle,
  position,
}: CreateLauncherButtonInput): HTMLButtonElement {
  const normalizedPosition = normalizeLauncherPosition(position);
  const button = document.createElement("button");
  const icon = document.createElement("span");

  button.type = "button";
  button.className = "migrosone-a11y-widget-button";
  button.dataset.position = normalizedPosition;
  button.setAttribute("aria-label", "Erişilebilirlik ayarlarını aç");
  button.setAttribute("aria-expanded", "false");
  button.setAttribute("aria-haspopup", "dialog");
  icon.className = "migrosone-a11y-widget-button__icon";
  icon.setAttribute("aria-hidden", "true");
  icon.innerHTML = accessibilityIconSvg;
  button.append(icon);
  button.addEventListener("click", onToggle);

  return button;
}
